import request from '@/utils/request'

// 获取批处理查询
export const GetDealCheckAPI = (data) => request.get('/users/batch_processing/', { params: data })
